import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SIGNUP_COLORS } from "../../../tokens";

const TopAuth: React.FC = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        pt: 2,
        pr: { xs: 2, md: 6 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          "@media (max-width:400px)": {
            flexDirection: "column",
            "& > *:first-of-type": { mb: 1 },
          },
        }}
      >
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ mr: 1, fontWeight: 500 }}
        >
          {translate("signup.right.haveAccount")}
        </Typography>
        <Button
          data-cy="redirectToSignIn"
          aria-label="redirectToSignIn"
          size="small"
          onClick={() => history.push("/signin")}
          sx={{
            backgroundColor: SIGNUP_COLORS.primary,
            color: "#fff",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
            borderRadius: "6px",
            px: 2,
            py: 0.5,
            "&:hover": {
              backgroundColor: "#004080",
            },
          }}
        >
          {translate("signup.right.signIn")}
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(TopAuth);
